import { quickEntries } from "@/mocks/home";

export default function JoinCTA() {
  return (
    <section id="join" className="hl-anchor w-full bg-primary-600">
      <div className="px-4 py-14 md:px-6 md:py-16 lg:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-50">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-megaphone-line text-sm" />
              </span>
              黑料51瓜友投稿通道
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
              手里有瓜？把它交给瓜田
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100/85 md:text-base">
              投稿可附带时间、地点、截图或原始回放，值班编辑会在核对后集中归档，并在讨论圈同步进度。
              你的每条线索，都会成为黑料51瓜友热议话题的一部分。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#top"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-line text-base" />
                </span>
                立即投稿线索
              </a>
              <a
                href="#community"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                先去讨论圈看看
              </a>
            </div>
          </div>

          <div className="grid w-full max-w-md grid-cols-2 gap-3 lg:w-auto">
            {quickEntries.map((entry) => (
              <a
                key={entry.href}
                href={entry.href}
                className="flex items-center gap-2.5 rounded-lg bg-background-50/10 px-4 py-4 transition-colors hover:bg-background-50/20"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${entry.icon} text-base`} />
                </span>
                <span className="whitespace-nowrap text-sm font-semibold text-background-50">
                  {entry.label}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}